import React, { Fragment, useEffect, useRef, useState } from "react";
import { dateParser } from "../../helper";

const AuditVersionHistory = (props: any) => {
  const { versionHistoryData } = props;

  const [reorderHistory, setReorderHistory] = useState(false);

  return (
    <div className="flex flex-col pw-detail-main-content  gap-5">
      <div className="pw-version-history">Version History</div>
      <div className="pw-version-history-content pw-border-1px-neutral pw-bg-neutral-50 ">
        {/* header */}
        <div className="pw-version-history-header py-2 pw-border-bottom-version-history w-full flex items-center">
          <div style={{ width: "30%" }} className="flex gap-x-4  ml-3">
            <div className="pw-text-neutral-600">Modified on</div>
            <div onClick={() => setReorderHistory(!reorderHistory)}>
              <img src="assets/icons/sort-alphabetical-descending.svg" alt="" />
            </div>
          </div>
          <div style={{ width: "70%" }} className="pw-text-neutral-600">
            Description
          </div>
        </div>
        <div
          className={`pw-version-history-users pw-bg-white flex ${
            !reorderHistory ? "flex-col" : "flex-col-reverse"
          } items-center `}
        >
          {versionHistoryData.map((eachHistory: any, index: any) => {
            const typeVersion = eachHistory.type;
            return typeVersion === "Update" ? (
              <div className="w-full">
                <div className="flex  w-full mt-2 p-2">
                  <div
                    style={{ width: "30%", paddingRight: "10px" }}
                    className="flex justify-between ml-3   pw-each-history"
                  >
                    <div>
                      <div className="pw-text-neutral-600">
                        {dateParser(eachHistory.created)}
                      </div>
                    </div>

                    <div style={{ width: "30px", height: "30px" }}>
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                        src={
                          eachHistory?.ownerProfileImageUrl ||
                          "assets/icons/account.svg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    style={{ color: "black", width: "70%" }}
                    className="pw-text-neutral-600 pw-each-history"
                  >
                    <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                      {" "}
                      updated the status from
                    </span>

                    <span
                      className={`pw-${"Requested".toLowerCase()} text-neutral-900 text-sm font-bold whitespace-nowrap mx-1  p-1`}
                    >
                      Requested
                    </span>
                    <span className="pr-1">to</span>
                    <span
                      className={`pw-${eachHistory.to_value?.toLowerCase()} p-1 whitespace-nowrap mx-1 text-neutral-900 text-sm font-bold mr-1`}
                    >
                      {eachHistory.to_value}
                    </span>
                  </div>
                </div>
                {eachHistory.comments?.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "flex-end",
                      padding: "10px",
                    }}
                    className="w-full flex mt-2"
                  >
                    <div style={{ width: "69%" }}>
                      <div className="pw-text-neutral-600">comments : </div>
                      <div className="mt-2 pw-text-neutral-900">
                        {eachHistory.comments || "-"}
                      </div>
                    </div>
                  </div>
                )}

                {/* {eachHistory?.attachments?.length > 0 && (
                  <VersionHistoryAttachments
                    eachAttachments={eachHistory?.attachments}
                  />
                )} */}
                <div
                  className={` pw-border-bottom-version-history w-full`}
                ></div>
              </div>
            ) : (
              <Fragment>
                <div
                  className={`flex w-full pw-border-bottom-version-history mt-2 p-2`}
                >
                  <div
                    style={{ width: "30%", paddingRight: "10px" }}
                    className="flex justify-between ml-3   pw-each-history"
                  >
                    <div>
                      <div className="pw-text-neutral-600">
                        {dateParser(eachHistory.created)}
                      </div>
                    </div>

                    <div style={{ width: "30px", height: "30px" }}>
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                        src={
                          eachHistory?.ownerProfileImageUrl ||
                          "assets/icons/account.svg"
                        }
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    style={{ color: "black", width: "70%" }}
                    className="pw-text-neutral-600 pw-each-history"
                  >
                    <span className="font-bold text-neutral-900 text-sm">
                      {eachHistory?.ownerDisplayName || "Super user"}
                    </span>
                    <span className="pw-word-spacing-2 text-neutral-900 text-sm">
                      {" "}
                      Created the audit request.
                    </span>
                  </div>
                </div>
              </Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default AuditVersionHistory;
